import { Radio, Text } from "@marketplace/ui";
import clsx from "clsx";

import classes from "./seller-type-radio.module.css";

type SellerTypeRadioProps = {
  title: string;
  description: string;
  icon: React.ReactNode;
  value: string;
};

export const SellerTypeRadio = ({
  title,
  description,
  icon,
  value
}: SellerTypeRadioProps) => {
  return (
    <Radio.Card
      value={value}
      className={clsx("flex items-center p-[14px] gap-x-2 text", classes.root)}
    >
      <div
        className={clsx(
          "flex justify-center items-center rounded-lg w-[62px] h-[62px]",
          classes.iconWrapper
        )}
      >
        {icon}
      </div>
      <div className="flex-1 text-fjord-grey-500">
        <Text type="heading" size="s" className="mb-2">
          {title}
        </Text>
        <Text>{description}</Text>
      </div>
    </Radio.Card>
  );
};
